import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './contexts/CartContext';
import UserMenu from './pages/UserMenu';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import CashierDashboard from './pages/CashierDashboard';
import CookDashboard from './pages/CookDashboard';
import SurveysPage from './pages/SurveysPage';
import TrackOrder from './pages/TrackOrder';
import UserLogin from './pages/UserLogin';
import UserCart from './pages/UserCart';
import OffersPage from './pages/OffersPage';
import OrderHistory from './pages/OrderHistory';
import PaymentDisplay from './pages/PaymentDisplay';
import PaymentNfcRedirect from './pages/PaymentNfcRedirect';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function RazorpayPreload() {
  React.useEffect(() => {
    if (document.getElementById('razorpay-checkout-script')) return;
    const script = document.createElement('script');
    script.id = 'razorpay-checkout-script';
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return null;
}

function App() {
  return (
    <ThemeProvider defaultTheme="dark">
      <AuthProvider>
        <SocketProvider>
          <CartProvider>
          <RazorpayPreload />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<UserMenu />} />
              <Route path="/surveys" element={<SurveysPage />} />
              <Route path="/track" element={<TrackOrder />} />
              <Route path="/login" element={<Login />} />
              <Route path="/user-login" element={<UserLogin />} />
              <Route path="/cart" element={<UserCart />} />
              <Route path="/orders" element={<OrderHistory />} />
              <Route path="/offers" element={<OffersPage />} />
              <Route path="/pay" element={<PaymentDisplay />} />
              <Route path="/pay/nfc" element={<PaymentNfcRedirect />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cashier"
                element={
                  <ProtectedRoute allowedRoles={['cashier', 'admin']}>
                    <CashierDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cook"
                element={
                  <ProtectedRoute allowedRoles={['cook', 'admin']}>
                    <CookDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster />
          </CartProvider>
        </SocketProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
